/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

//  error msg dispatch function
export const dispatchErrorMsgTopBalances = (data) => ({
  type: actionTypes.GET_ERROR_MSG_TOP_BALANCES,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgTopBalances([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgTopBalances([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_BALANCES,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_BALANCES,
  detailScrData: data,
});
//quarter range display
export const dispatchQuarterRangeObj = (data) => ({
  type: actionTypes.DISPLAY_QUARTER_OBJ,
  payload: data,
});
//refresh data
export const refreshTopBalances = () => ({
  type: actionTypes.SET_REFRESH_DATA_BALANCES,
  payload: {},
});
export const refreshTopBalancesDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_BALANCES_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjBalances = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_BALANCES,
  payload: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_BALANCES,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_BALANCES,
  payload: data,
});
// rebate program name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_BALANCES,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

//QUarter range dispatch
export const dispatchQuarterRange = (data) => ({
  type: actionTypes.DISPLAY_QUARTER_RANGE,
  payload: data,
});
//dispatch quarter from
export const dispatchFromBalances = (data) => ({
  type: actionTypes.GET_FROM_BALANCES,
  payload: data,
});
//dispatch quarter to
export const dispatchToBalances = (data) => ({
  type: actionTypes.GET_TO_BALANCES,
  payload: data,
});
//dispatch DRAMS
export const dispatchDRAMS = (data) => ({
  type: actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});
//dispatch FirstSummaryReportQTROption
export const dispatchFirstSummaryReport = (data) => ({
  type: actionTypes.GET_FIRST_SUMMARY_REPORT_OPTION,
  payload: data,
});
// credit debit index
export const dispatchCreditDebitIndex = (data) => ({
  type: actionTypes.SET_CREDIT_DEBIT_OPTION,
  payload: data,
});
//top balances credit debit dispatch function
export const dispatchCreditDebit = (data) => ({
  type: actionTypes.GET_CREDIT_DEBIT,
  payload: data,
});

export const setPaginationIndex = (value) => ({
  type: actionTypes.SET_PAGINATION_INDEX_TO_BALANCE,

  payload: value,
});
//manufacturer dispatch function
export const dispatchManufacturerNo = (data) => ({
  type: actionTypes.DISPLAY_MANUFACTURE_NO,
  payload: data,
});
export const setManufacturerNo = (data) => ({
  type: actionTypes.SET_MANUFACTURE_NO,
  payload: data,
});
//dispatch balance due
export const dispatchBalanceDue = (data) => ({
  type: actionTypes.GET_BALANCE_DUE,
  payload: data,
});

//get credit debit

export const getCreditDebit = (value) => (dispatch) => {
  dispatch(dispatchCreditDebit([]));
  return axios
    .post(serviceEndPoint.TOP_BALANCES_CREDIT_DEBIT, value)
    .then((response) => {
      if (response.data.rebateTopBalancesGridReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchCreditDebit(response.data));
        return response.data;
      }
    })
    .catch((response) => {
      dispatch(dispatchCreditDebit([]));
    });
};

export const setDetailTopBalList = (payload) => ({
  type: actionTypes.DISP_DETAIL_TOP_BAL_DATA,
  payload,
});

//get top balance
export const getTopBalances = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TOP_BALANCES, value)
    .then((response) => {
      // if (response.data.rebateTopBalancesReportVO.length == 0) {
      //   dispatch(showNoDataMessage());
      // } else {
      dispatch(dispatchBalanceDue(response.data));
      return response.data;
      // }
    })
    .catch((response) => {
      dispatch(dispatchBalanceDue([]));
    });
};
//get DRAMS
export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response.data.dramsInvoiceStartQuarter));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS([]));
    });
};
// get first summary quarter option
export const getFirstSummaryReportQuarter = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_FIRST_SUMMARY_REPORT_OPTION, value)
    .then((response) => {
      return dispatch(dispatchFirstSummaryReport(response.data));
    })
    .catch((response) => {
      dispatch(dispatchFirstSummaryReport([]));
    });
};

//dispatch credit mfg
export const dispatchCreditMfg = (data) => ({
  type: actionTypes.GET_CREDIT_MFG_BALANCES,
  payload: data,
});
export const getCreditMfg = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TOP_BALANCES_CREDIT_MFG, value)
    .then((response) => {
      return dispatch(dispatchCreditMfg(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCreditMfg([]));
    });
};
//dispatch debit mfg
export const dispatchDebitMfg = (data) => ({
  type: actionTypes.GET_DEBIT_MFG_BALANCES,
  payload: data,
});
export const getDebitMfg = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TOP_BALANCES_DEBIT_MFG, value)
    .then((response) => {
      return dispatch(dispatchDebitMfg(response.data));
    })
    .catch((response) => {
      dispatch(dispatchDebitMfg([]));
    });
};
//dispatch dateRange
export const dispatchDateRange = (data) => ({
  type: actionTypes.GET_DATE_RANGE,
  payload: data,
});
//export all
export const setExportAll = (data) => ({
  type: actionTypes.SET_EXPORT_ALL_TOP_BALANCES,
  payload: data,
});
export const reportData = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TOP_BALANCES_CREDIT_DEBIT, values)
    .then((response) => {
      dispatch(setExportAll(response?.data?.rebateTopBalancesGridReportVO));
    })
    .catch((response) => {
      dispatch(setExportAll([]));
    });
};
export const getExportAllData =
  ({ rebateProgramCd, mfgId, startQtr, endQtr }, getManufacturerListData) =>
  (dispatch) => {
    // dispatch(setExportAll({}));
    let allMfgId = [];

    for (let i = 0; i < getManufacturerListData; i++) {
      allMfgId.push(mfgId[i]?.mfgId);
    }
    const values = {
      rebateProgramCd,
      mfgId: allMfgId,
      startQtr,
      endQtr,
    };
    dispatch(reportData(values));
  };
